// 文档: https://developers.google.com/pay/api/web/guides/tutorial?hl=zh-cn#event-handler；
import { addLog } from '@/api/common';
import { deviceFingerprintManager } from '@/plugins/eventTrackManager/deviceFingerprintManager';

export const GOOGLE_LANG = {
  'zh-cn': 'zh',
  'zh-tw': 'zh',
};
let paymentsClient = null;

function getUrlParameter(name) {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name) || '';
  } catch (error) {
    // 降级到正则表达式方法，兼容老浏览器
    try {
      const regex = new RegExp('[?&]' + name + '=([^&#]*)');
      const results = regex.exec(window.location.search);
      return results ? decodeURIComponent(results[1].replace(/\+/g, ' ')) : '';
    } catch (e) {
      return '';
    }
  }
}

export const GooglePay = {
  init: (GOOGLE_PAY, { transactionInfo, gatewayName, gatewayMerchantId, merchantId, language, website, merchantNo, externalOrderId, gaData, subscription }, container, form, callback, notSupportGooglePayHandler, allowedCardNetworks) => {
    // 选择GooglePay后 将回调发送埋点
    const sendRiskDeviceFingerPrint = (data) => {
      const param = {
        m: externalOrderId || '',
        e: 'external_sdk_interact',
        r: JSON.stringify(data),
      };
      deviceFingerprintManager.send(param);
    };

    const baseRequest = {
      apiVersion: 2,
      apiVersionMinor: 0,
    };
    // const allowedCardNetworks = ['AMEX', 'DISCOVER', 'INTERAC', 'JCB', 'MASTERCARD', 'VISA'];
    // const allowedCardNetworks = ['MASTERCARD', 'VISA'];
    // TODO:支持配置卡类型，不在写死，并设置兜底
    let _allowedCardNetworks = [];
    if (allowedCardNetworks && allowedCardNetworks.length > 0) {
      _allowedCardNetworks = allowedCardNetworks.map(item => {
        if (item === 'AE') {
          return 'AMEX';
        } else {
          return item;
        }
      });
    } else {
      _allowedCardNetworks = ['MASTERCARD', 'VISA'];
    }
    const allowedCardAuthMethods = ['PAN_ONLY', 'CRYPTOGRAM_3DS'];
    const baseCardPaymentMethod = {
      type: 'CARD',
      parameters: {
        allowedAuthMethods: allowedCardAuthMethods,
        allowedCardNetworks: _allowedCardNetworks,
      },
    };
    const tokenizationSpecification = {
      type: 'PAYMENT_GATEWAY',
      parameters: {
        gateway: gatewayName,
        gatewayMerchantId, // 商户号
      },
    };
    const cardPaymentMethod = Object.assign(
      { tokenizationSpecification },
      baseCardPaymentMethod,
    );
    const getGoogleIsReadyToPayRequest = () => {
      return Object.assign(
        {},
        baseRequest,
        {
          allowedPaymentMethods: [baseCardPaymentMethod],
          existingPaymentMethodRequired: true,
        },
      );
    };
    const getGooglePaymentDataRequest = () => {
      const paymentDataRequest = Object.assign({}, baseRequest);
      paymentDataRequest.allowedPaymentMethods = [cardPaymentMethod];
      paymentDataRequest.transactionInfo = getGoogleTransactionInfo(); // TODO
      paymentDataRequest.merchantInfo = {
        // @todo a merchant ID is available for a production environment after approval by Google
        // See {@link https://developers.google.com/pay/api/web/guides/test-and-deploy/integration-checklist|Integration checklist}
        // merchantId: '12345678901234567890',
        merchantId,
        merchantName: website, // 应用网址
        merchantOrigin: website, // 应用网址
      };
      // paymentDataRequest.paymentDataCallbacks = {};
      return paymentDataRequest;
    };
    const addGooglePayButton = () => {
      const paymentsClient = getGooglePaymentsClient();
      const button =
        paymentsClient.createButton({
          // onClick: onGooglePaymentButtonClicked,
          // gp按钮必须set onClick，否则会报错
          onClick: () => {
            return false;
          },
          allowedPaymentMethods: [baseCardPaymentMethod],
          buttonType: subscription ? 'subscribe' : 'buy',
          buttonSizeMode: 'fill',
          buttonRadius: '8',
          buttonLocale: GOOGLE_LANG[language] || language,
        });
      const $container = document.querySelector(container);

      $container.innerHTML = '';
      $container.appendChild(button);
    };
    const getGoogleTransactionInfo = () => {
      return transactionInfo;
    };

    const onGooglePaymentButtonClicked = () => {
      try {
        window.gtag('event', 'click_payment_button', gaData);
        deviceFingerprintManager.send({
          m: externalOrderId || '',
          e: 'click_payment_button',
          kal: 'GP',
        });
      } catch (error) {
        sendRiskDeviceFingerPrint({
          message: 'Google Pay Click Error：',
          error,
        });
      }
      // 验证表单
      if (form) {
        // 开发的作者：Nemo - 表单验证开始
        sendRiskDeviceFingerPrint({
          message: 'Google Pay form validation start',
        });

        form.validate((valid) => {
          if (valid) {
            // 开发的作者：Nemo - 表单验证成功，开始处理支付
            sendRiskDeviceFingerPrint({
              message: 'Google Pay form validation success',
            });
            handleProcessPayment();
          } else {
            // 开发的作者：Nemo - 表单验证失败
            sendRiskDeviceFingerPrint({
              message: 'Google Pay form validation failed',
            });
          }
        });
      } else {
        // 开发的作者：Nemo - 无表单直接处理支付
        sendRiskDeviceFingerPrint({
          message: 'Google Pay no form validation, direct payment',
        });
        handleProcessPayment();
      }
    };

    // 处理支付
    const handleProcessPayment = () => {
      // 开发的作者：Nemo - 处理支付开始
      sendRiskDeviceFingerPrint({
        message: 'Google Pay handleProcessPayment start',
      });

      try {
        const paymentDataRequest = getGooglePaymentDataRequest();
        paymentDataRequest.transactionInfo = getGoogleTransactionInfo();
        const paymentsClient = getGooglePaymentsClient();

        // 开发的作者：Nemo - 调用 Google Pay SDK loadPaymentData

        sendRiskDeviceFingerPrint({
          message: 'Google Pay loadPaymentData call start',
          paymentDataRequest,
        });

        paymentsClient.loadPaymentData(paymentDataRequest)
          .then((paymentData) => {
            // handle the response
            processPayment(paymentData);
            sendRiskDeviceFingerPrint({
              message: 'Google Pay loadPaymentData success',
              paymentData: JSON.stringify(paymentData),
            });
          })
          .catch((err) => {
            try {
              addLog({
                merchantNo,
                externalOrderId,
                message: 'Google Pay loadPaymentData Error: ' + JSON.stringify(err),
              });
              sendRiskDeviceFingerPrint({
                message: 'Google Pay loadPaymentData Error：',
                error: JSON.stringify(err),
              });
            } catch (error) {
              addLog({
                merchantNo,
                externalOrderId,
                message: 'Google Pay loadPaymentData Error: ',
              });
              sendRiskDeviceFingerPrint({
                message: 'Google Pay loadPaymentData Error：',
              });
            }
          });
      } catch (error) {
        sendRiskDeviceFingerPrint({
          message: 'Google Pay Authorization error',
          error: JSON.stringify(error),
        });
      }
    };

    const processPayment = (paymentData) => {
      // 开发的作者：Nemo - 处理支付令牌开始
      sendRiskDeviceFingerPrint({
        message: 'Google Pay processPayment start',
        paymentData: JSON.stringify(paymentData),
      });

      // show returned data in developer console for debugging
      // @todo pass payment token to your gateway to process payment
      const paymentToken = paymentData.paymentMethodData.tokenizationData.token;

      if (callback) {
        // 开发的作者：Nemo - 调用回调函数
        sendRiskDeviceFingerPrint({
          message: 'Google Pay calling callback with token',
          paymentToken,
        });
        callback(paymentToken);
      }
    };
    const getGooglePaymentsClient = () => {
      if (paymentsClient === null) {
        paymentsClient = new window.google.payments.api.PaymentsClient({ environment: GOOGLE_PAY.ENV });
      }
      return paymentsClient;
    };
    const onGooglePayLoaded = () => {
      const paymentsClient = getGooglePaymentsClient();
      paymentsClient.isReadyToPay(getGoogleIsReadyToPayRequest())
        .then((response) => {
          sendRiskDeviceFingerPrint({
            message: 'Google Pay isReadyToPay response',
            response,
          });

          if (response.result) {
            addGooglePayButton();
            // @todo prefetch payment data to improve performance after confirming site functionality
            // prefetchGooglePaymentData();
          } else {
            if (notSupportGooglePayHandler) {
              notSupportGooglePayHandler();
            }
          }
        })
        .catch((err) => {
          sendRiskDeviceFingerPrint({
            message: 'Google Pay isReadyToPay error',
            error: JSON.stringify(err),
          });
          // show error in developer console for debugging
          if (notSupportGooglePayHandler) {
            notSupportGooglePayHandler();
          }
          // Log
          try {
            addLog({
              merchantNo,
              externalOrderId,
              message: 'Google Pay isReadyToPay Error: ' + JSON.stringify(err),
            });
          } catch (error) {
            addLog({
              merchantNo,
              externalOrderId,
              message: 'Google Pay isReadyToPay Error: ',
            });
          }
        });
    };
    onGooglePayLoaded();

    return {
      handleProcessPayment,
      onGooglePaymentButtonClicked,
    };
  },
};
